import "./Loader.css";
import logo from "../../assets/images/nnfitprimarylogo.png"; // update path

export default function Loader() {
  return (
    <div className="loader-page">
      <div className="loader-wrapper">
        <div className="loader-ring"></div>

        <img src={logo} alt="NN AI Solutions" className="loader-logo" />
      </div>

      <h2>NN FIT </h2>

      <p>Powered By NN FIT</p>
    </div>
  );
}
